/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactHistoryModel } from '../../models/client-survey-contact-history-model';

export interface GetSurveyContactHistoryAsync$Plain$Params {

/**
 * surveycontacthistory id filter
 */
  surveyContactHistoryId: number;
}

export function getSurveyContactHistoryAsync$Plain(http: HttpClient, rootUrl: string, params: GetSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactHistoryModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyContactHistoryAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('surveyContactHistoryId', params.surveyContactHistoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyContactHistoryModel>;
    })
  );
}

getSurveyContactHistoryAsync$Plain.PATH = '/api/SurveyContactHistory/{surveyContactHistoryId}';
